import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import Icon from "./_internal/Icon";
var EyeInvisibleOutlined = /*#__PURE__*/React.forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/React.createElement("svg", _extends({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("path", {
    d: "M512 149.333c96.213 0 188.544 31.68 265.493 79.382l66.838-66.88a42.667 42.667 0 0162.848 57.6l-2.496 2.73-682.518 682.667a42.667 42.667 0 01-62.826-57.6l2.496-2.73 63.189-63.233a559.83 559.83 0 01-32.213-23.786l-10.987-8.96C96.981 677.333 42.667 587.755 42.667 512c0-75.776 54.314-165.333 139.157-236.501l11.008-8.982C278.379 198.464 392.192 149.333 512 149.333zm368.213 161.344c62.699 64.107 101.12 137.6 101.12 201.323 0 75.776-54.314 165.333-139.157 236.501l-11.008 8.982C745.621 825.536 631.808 874.667 512 874.667c-57.28 0-113.173-11.222-165.29-30.379l68.373-68.373c31.85 8.597 64.49 13.418 96.917 13.418 187.883 0 384-162.346 384-277.333 0-44.224-29.013-95.445-75.37-141.739l59.583-59.584zM512 234.667c-187.883 0-384 162.346-384 277.333 0 66.901 66.347 149.803 158.848 207.445l95.915-95.957a170.667 170.667 0 01240.704-240.725l91.349-91.371C653.12 257.195 581.995 234.667 512 234.667zm-3.648 447.936l174.293-174.294.022 3.691A170.667 170.667 0 01512 682.667l-3.648-.064zM512 426.667a85.333 85.333 0 00-68.544 136.17l119.36-119.402A84.95 84.95 0 00512 426.667z"
  }));
  return /*#__PURE__*/React.createElement(Icon, _extends({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
EyeInvisibleOutlined.displayName = "EyeInvisibleOutlined";
export default EyeInvisibleOutlined;